import { string, func } from 'prop-types'
import AppBar from '@material-ui/core/AppBar'
import IconButton from '@material-ui/core/IconButton'
import MenuIcon from '@material-ui/icons/Menu'
import Toolbar from '@material-ui/core/Toolbar'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'

export const Header = (props) => {
  const classes = styles(props)
  const { title, menuAction } = props
  return (
    <div className={classes.header}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          {menuAction && (
            <IconButton
              onClick={menuAction}
              classes={{ root: classes.button }}
              aria-label="Menu"
            >
              <MenuIcon />
            </IconButton>
          )}
          <img src="/logo.svg" className={classes.logo} alt="Logo" />
          <Typography component="span" variant="h6" color="inherit">
            {title}
          </Typography>
        </Toolbar>
      </AppBar>
    </div>
  )
}

Header.displayName = 'Header'

Header.propTypes = {
  title: string.isRequired,
  menuAction: func,
}

Header.defaultProps = {}

const styles = makeStyles((theme) => ({
  header: {
    height: 56,
    [`${theme.breakpoints.up('xs')} and (orientation: landscape)`]: {
      height: 48,
    },
    [theme.breakpoints.up('sm')]: {
      height: 64,
    },
  },
  appBar: {},
  logo: {
    height: 40,
    margin: '0 18px 0 6px',
    width: 35,
  },
  button: {
    color: theme.palette.primary.contrastText,
  },
}))

export default Header
